'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var requiredError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This is a required field';
  var invalidError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invalid sort code';
  return function (sortcode) {
    if (!Array.isArray(sortcode) || sortcode.length !== 3) {
      return (0, _getErrorMessage2.default)(requiredError, {
        value: sortcode
      });
    }
    var regEx = /^\d{2}$/;
    if (sortcode.every(function (value) {
      return regEx.test(value);
    })) {
      return '';
    }
    return (0, _getErrorMessage2.default)(invalidError, {
      value: sortcode
    });
  };
};